export default new (class ThemeManager {
  constructor() {
    this.systemThemeQuery = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
  }

  /**
   * Detect system dark theme preference
   * @returns {boolean} true if system prefers dark theme
   */
  getSystemTheme() {
    return this.systemThemeQuery && this.systemThemeQuery.matches;
  }

  /**
   * Apply theme to body element
   * @param {boolean} isDark - whether to apply dark theme
   */
  applyTheme(isDark) {
    if (isDark) {
      document.body.classList.add('dark-theme');
    } else {
      document.body.classList.remove('dark-theme');
    }
  }

  /**
   * Apply theme based on user data
   * @param {Object} userData - user object with darkTheme property
   */
  applyUserTheme(userData) {
    this.applyTheme(userData?.darkTheme);
  }

  /**
   * Apply system theme
   */
  applySystemTheme() {
    this.applyTheme(this.getSystemTheme());
  }

  /**
   * Listen for system theme changes
   * @param {Function} callback - function to call when theme changes
   */
  onSystemThemeChange(callback) {
    if (this.systemThemeQuery) {
      this.systemThemeQuery.addEventListener('change', (e) => {
        callback(e.matches);
      });
    }
  }

  /**
   * Remove system theme change listener
   * @param {Function} callback - the callback function to remove
   */
  removeSystemThemeListener(callback) {
    if (this.systemThemeQuery) {
      this.systemThemeQuery.removeEventListener('change', callback);
    }
  }
})();
